<form-group>
  <session-selector-form-item
    [value]="sessionId"
    [labelText]="'session' | localize"
    [placeholder]="'search_for_session' | localize"
    [required]="true"
    (valueChange)="handleSessionChange($event)"
    e2eTestId="session-selector-dropdown"
    controlName="sessionId"></session-selector-form-item>
  <text-form-item
    [labelText]="'title' | localize"
    [placeholder]="'enter_objective_title' | localize"
    [maxCharsCount]="nameConfig.maxChars"
    [required]="true"
    [validators]="nameConfig.validators"
    e2eTestId="enter-objective-name"
    controlName="name"></text-form-item>
  <assignee-form-item
    [labelText]="'owner_cap' | localize"
    [placeholder]="'search_for_owner' | localize"
    [required]="true"
    [mode]="ownerSelectorConfig.mode"
    [request]="ownerSelectorConfig.request"
    [validators]="ownerSelectorConfig.validators"
    [errorMessages]="{
      usersCannotBeOwners: 'teams_only_assign_err_msg' | localize,
      teamsCannotBeOwners: 'users_only_assign_err_msg' | localize,
    }"
    e2eTestId="objective-modal-owner-field"
    controlName="ownerIds">
  </assignee-form-item>
  <toggle-form-item *ngIf="canOkrBePrivate" [value]="false" [labelText]="'make_private' | localize" controlName="private"></toggle-form-item>
  <custom-fields-form-item *ngIf="sessionId" [filter]="customFieldsFilter" target="goal" controlName="customFields"></custom-fields-form-item>
</form-group>
